<app-i18n-watcher></app-i18n-watcher>
@if (isOffline()) {
  <div class="offline-banner">
    <div class="banner-inner">
      <span class="offline-dot"></span>
      <span class="offline-text">{{
        'common.offlineMessage' | translate
      }}</span>
      <button class="offline-close" (click)="isOffline.set(false)">×</button>
    </div>
  </div>
}

<!-- @if(isLoading()){
    <app-spinner [isMain]="true"></app-spinner>
} -->

@if (showInstallButton) {
  <div
    class="fixed top-3 left-3 right-3 md:top-6 md:right-6 md:left-auto bottom-auto z-[1000] w-auto max-w-none md:max-w-[480px] bg-white text-slate-800 rounded-2xl md:rounded-[20px] border border-slate-200/80 shadow-[0_10px_30px_rgba(0,0,0,0.08)] overflow-hidden install-banner">
    <div class="flex items-center p-3.5 md:p-4.5 gap-3 md:gap-4">
      <!-- Left Illustration -->
      <div class="flex-shrink-0">
        <img
          src="../assets/icons/actions/install.png"
          alt="{{ 'install' | translate }}"
          class="w-11 h-11 md:w-13 md:h-13 object-contain" />
      </div>
      <!-- Center Text -->
      <div class="flex-1 flex flex-col gap-0.5 text-left min-w-0">
        <h4
          class="margin-0 font-extrabold text-xs md:text-sm text-slate-900 leading-tight truncate">
          {{ 'installTitle' | translate }}
          <span class="text-blue-600">{{
            'installForBetterExperience' | translate
          }}</span>
        </h4>
        <p
          class="margin-0 text-[10px] md:text-[11px] text-slate-500 font-semibold leading-relaxed line-clamp-2">
          {{ 'installDescription' | translate }}
        </p>
      </div>
      <!-- Right Action Buttons -->
      <div class="flex items-center gap-2 md:gap-2.5 flex-shrink-0">
        <button
          class="bg-[#2b4582] hover:bg-[#1e305e] text-white border-none py-1.5 px-3 md:py-2 md:px-4 font-bold text-[10px] md:text-xs rounded-lg md:rounded-xl transition-all shadow-sm hover:shadow-md cursor-pointer tracking-wider"
          (click)="onInstallPwa()">
          {{ 'install' | translate | uppercase }}
        </button>
        <button
          class="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center rounded-full bg-[#b9cadb] hover:bg-slate-400 text-white transition-all cursor-pointer border-none"
          (click)="cancel()"
          aria-label="Close">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-3 h-3 md:w-3.5 md:h-3.5">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
}

@if (showUpdateNotification) {
  <div
    class="fixed top-3 left-3 right-3 md:top-6 md:right-6 md:left-auto bottom-auto z-[1000] w-auto max-w-none md:max-w-[480px] bg-[var(--sam-teacher-primary,#3F5480)] text-white rounded-2xl md:rounded-[20px] shadow-[0_10px_35px_rgba(63,84,128,0.3)] overflow-hidden install-banner update-banner"
    style="font-family: var(--teacher-font, 'Noto Sans', sans-serif);">
    <div class="flex items-center p-3.5 md:p-4.5 gap-3 md:gap-4">
      <!-- Left Icon -->
      <div class="flex-shrink-0 bg-white/20 p-2 rounded-xl">
        <svg
          class="w-5 h-5 md:w-6 md:h-6 text-white"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 1121.253 8H18" />
        </svg>
      </div>
      <!-- Center Text -->
      <div class="flex-1 flex flex-col gap-0.5 text-left min-w-0">
        <h4
          class="margin-0 font-extrabold text-xs md:text-sm text-white leading-tight">
          {{ 'common.updateAvailableTitle' | translate }}
        </h4>
        <p
          class="margin-0 text-[10px] md:text-[11px] text-blue-100 font-semibold leading-relaxed line-clamp-2">
          {{ 'common.updateAvailable' | translate }}
        </p>
      </div>
      <!-- Right Action Buttons -->
      <div class="flex items-center gap-2 md:gap-2.5 flex-shrink-0">
        <button
          class="bg-white text-[var(--sam-teacher-primary,#3F5480)] hover:bg-slate-50 border-none py-1.5 px-3 md:py-2 md:px-4 font-bold text-[10px] md:text-xs rounded-lg md:rounded-xl transition-all shadow-sm hover:shadow-md cursor-pointer tracking-wider"
          (click)="reloadApp()">
          {{ 'common.updateNow' | translate }}
        </button>
        <button
          class="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 text-white transition-all cursor-pointer border-none"
          (click)="showUpdateNotification = false"
          aria-label="Close">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-3 h-3 md:w-3.5 md:h-3.5">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  </div>
}
<router-outlet></router-outlet>
<app-alert></app-alert>
<app-toast></app-toast>
<app-notification-prompt></app-notification-prompt>
<app-ai-assistant-premium-modal></app-ai-assistant-premium-modal>
<app-voice-assistant-fab></app-voice-assistant-fab>
